import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagged: {
		id: 'native-issue-table.common.issue-cells.flag.flagged',
		defaultMessage: 'Impediment',
		description: 'Message shown when an issue has been flagged as important or blocked.',
	},
});
